import React from "react";
import {css} from "@panda/css";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {LeadModalPriceConversationConsultant} from "../../../../lead/components/lead_modal/lead_modal_price_conversation_step/lead_modal_price_conversation/LeadModalPriceConversationConsultant";

interface IProps {
    multipleLeadsSend: boolean;
}

export const PreferencesModalHeading = (props: IProps) => {
    const message = props.multipleLeadsSend
        ? "Właśnie przekazaliśmy Twoje wiadomości do biur sprzedaży."
        : "Właśnie przekazaliśmy Twoją wiadomość do biura sprzedaży.";

    return (
        <div className={heading}>
            <LeadModalPriceConversationConsultant variant="large" className={consultantStyle} />
            <div className={applicationInfo}>
                <BrandCheckboxCheckedIcon size="4.4" wrapperSize="4.4" wrapperColor={getThemeVariable("colors.primary")} />
                <Text variant="body_copy_2">{message}</Text>
            </div>
        </div>
    );
};

const heading = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    alignItems: "center",
    justifyContent: "space-between",

    md: {
        flexDirection: "row",
        gap: 5.5,
        backgroundColor: "var(--colors-gray-100)",
        pr: 2
    }
});

const consultantStyle = css({
    width: "100%",

    md: {
        borderBottom: "none",
        width: "auto",
        m: "unset"
    }
});

const applicationInfo = css({
    backgroundColor: "var(--colors-success)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: "60px",
    width: "calc(100% - var(--spacing-4))",
    gap: 1,
    borderRadius: 1,
    p: 1,

    md: {
        gap: 2,
        maxWidth: "376px"
    }
});
import React from "react";
import {css} from "@panda/css";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {LeadModalPriceConversationConsultant} from "../../../../lead/components/lead_modal/lead_modal_price_conversation_step/lead_modal_price_conversation/LeadModalPriceConversationConsultant";

interface IProps {
    multipleLeadsSend: boolean;
}

export const PreferencesModalHeading = (props: IProps) => {
    const message = props.multipleLeadsSend
        ? "Właśnie przekazaliśmy Twoje wiadomości do biur sprzedaży."
        : "Właśnie przekazaliśmy Twoją wiadomość do biura sprzedaży.";

    return (
        <div className={heading}>
            <LeadModalPriceConversationConsultant variant="large" className={consultantStyle} />
            <div className={applicationInfo}>
                <BrandCheckboxCheckedIcon size="4.4" wrapperSize="4.4" wrapperColor={getThemeVariable("colors.primary")} />
                <Text variant="body_copy_2">{message}</Text>
            </div>
        </div>
    );
};

const heading = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    alignItems: "center",
    justifyContent: "space-between",

    md: {
        flexDirection: "row",
        gap: 5.5,
        backgroundColor: "var(--colors-gray-100)",
        pr: 2
    }
});

const consultantStyle = css({
    width: "100%",

    md: {
        borderBottom: "none",
        width: "auto",
        m: "unset"
    }
});

const applicationInfo = css({
    backgroundColor: "var(--colors-success)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: "60px",
    width: "calc(100% - var(--spacing-4))",
    gap: 1,
    borderRadius: 1,
    p: 1,

    md: {
        gap: 2,
        maxWidth: "376px"
    }
});
